export default {"src":"/_next/static/media/user_login.56c0124b.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};